/* DEM PADEL theme JS */
(function(){
  const $=s=>document.querySelector(s),$$=s=>document.querySelectorAll(s);
  const fmt=n=>new Intl.NumberFormat('fr-FR',{style:'currency',currency:(window.Shopify&&Shopify.currency&&Shopify.currency.active)||'EUR'}).format(n/100);

  // Mobile menu
  const mm=$('#MobileMenu');
  $$('[data-mobile-open]').forEach(b=>b.addEventListener('click',()=>{mm&&mm.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}));
  $$('[data-mobile-close]').forEach(b=>b.addEventListener('click',()=>{mm&&mm.setAttribute('aria-hidden','true');document.body.style.overflow=''}));

  // Cart drawer
  const drawer=$('#CartDrawer');
  function openDrawer(){if(!drawer)return;drawer.setAttribute('aria-hidden','false');document.body.style.overflow='hidden'}
  function closeDrawer(){if(!drawer)return;drawer.setAttribute('aria-hidden','true');document.body.style.overflow=''}
  $$('[data-cart-open]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();openDrawer();renderCart()}));
  $$('[data-cart-close]').forEach(b=>b.addEventListener('click',closeDrawer));

  async function fetchCart(){const r=await fetch('/cart.js',{headers:{Accept:'application/json'}});return r.json()}
  async function changeLine(key,quantity){await fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity})});return fetchCart()}
  async function addToCart(id,qty=1){const r=await fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items:[{id,quantity:qty}]})});return r.json()}
  window.demAdd=async function(id,qty){try{await addToCart(id,qty||1);openDrawer();renderCart();updateCount()}catch(e){console.error(e)}};

  function updateProgress(total){
    const threshold=parseInt(getComputedStyle(document.documentElement).getPropertyValue('--free-shipping'),10)||150;
    const target=threshold*100;
    const pct=Math.min(100,Math.round((total/target)*100));
    const bar=$('[data-shipping-bar]');
    const text=$('[data-shipping-text]');
    if(bar)bar.style.width=pct+'%';
    if(text){if(total>=target)text.innerHTML='Bravo, livraison offerte ! 🎉';else text.innerHTML='Plus que <strong>'+fmt(target-total)+'</strong> pour la livraison offerte 🚚'}
  }
  async function renderCart(){
    const c=await fetchCart();
    const body=$('[data-cart-body]'),footer=$('[data-cart-footer]'),totalEl=$('[data-cart-total]');
    if(!body)return;
    if(!c.items.length){body.innerHTML='<div class="cart-drawer__empty"><p>Votre panier est vide.</p><a href="/collections/nos-raquettes" class="btn btn--primary">Découvrir nos raquettes</a></div>';if(footer)footer.hidden=true;updateProgress(0);return}
    const lines=c.items.map(it=>`<div class="cart-line" data-key="${it.key}"><img src="${it.featured_image.url}" alt=""><div class="cart-line__info"><div class="cart-line__name">${it.product_title}</div>${it.variant_title&&it.variant_title!=='Default Title'?`<div class="cart-line__variant">${it.variant_title}</div>`:''}<div class="cart-line__bottom"><div class="qty"><button data-q-minus>−</button><input value="${it.quantity}" readonly><button data-q-plus>+</button></div><strong>${fmt(it.final_line_price)}</strong></div><a class="cart-line__remove" data-q-remove href="#">Retirer</a></div></div>`).join('');
    body.innerHTML=lines;
    if(totalEl)totalEl.textContent=fmt(c.total_price);
    if(footer)footer.hidden=false;
    updateProgress(c.total_price);
    body.querySelectorAll('.cart-line').forEach(line=>{
      const key=line.getAttribute('data-key');const input=line.querySelector('input');
      line.querySelector('[data-q-plus]').addEventListener('click',async()=>{await changeLine(key,parseInt(input.value)+1);renderCart();updateCount()});
      line.querySelector('[data-q-minus]').addEventListener('click',async()=>{await changeLine(key,Math.max(0,parseInt(input.value)-1));renderCart();updateCount()});
      line.querySelector('[data-q-remove]').addEventListener('click',async e=>{e.preventDefault();await changeLine(key,0);renderCart();updateCount()});
    });
  }
  async function updateCount(){const c=await fetchCart();$$('[data-cart-count]').forEach(el=>{el.textContent=c.item_count;el.style.display=c.item_count?'flex':'none'})}

  // PDP add-to-cart form
  $$('form[action*="/cart/add"]').forEach(f=>{
    f.addEventListener('submit',async e=>{
      e.preventDefault();const fd=new FormData(f);const variantId=fd.get('id');const qty=parseInt(fd.get('quantity')||1);
      try{await addToCart(variantId,qty);openDrawer();renderCart();updateCount()}catch(err){console.error(err)}
    });
  });

  // FAQ accordion (uses <details>)
  // Already native

  // Init
  document.addEventListener('DOMContentLoaded',()=>{updateCount()});
})();
